import { Icon } from '@mui/material'
import { TooltipText } from 'components/TooltipText/TooltipText'
import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'
import { ReactComponent as IconAdd } from 'assets/images/icon-vector-add.svg'
import { ReactComponent as IconImport } from 'assets/images/icon-import.svg'
import { Dispatch, SetStateAction } from 'react'
import { useServiceAreas } from 'providers/ServiceAreasProvider'
import { DeliveryArea } from 'types/model/serviceAreas'
import { MapBtn, MapBtnWrapper } from './ServiceArea.styled'

type MapBtnsProps = {
  drawingModeEnabled: number | null
  setDrawingModeEnabled: Dispatch<SetStateAction<number | null>>
  drawnPath: { lat: number; lng: number }[][] | []
  handleOpenVectorModal: () => void
  setCoordinates: Dispatch<SetStateAction<DeliveryArea[][]>>
}

export const MapButtons = ({
  drawingModeEnabled,
  drawnPath,
  setDrawingModeEnabled,
  setCoordinates,
  handleOpenVectorModal,
}: MapBtnsProps) => {
  const { selectedDeliveryArea } = useServiceAreas()
  const { t } = useTranslation()
  return (
    <MapBtnWrapper
      visible={
        drawingModeEnabled === selectedDeliveryArea.id || drawnPath.length > 0
          ? 'none'
          : 'flex'
      }>
      <MapBtn
        aria-label={t('serviceArea.newImportArea')}
        onClick={() => {
          setDrawingModeEnabled(selectedDeliveryArea.id)
          setCoordinates([])
        }}
        marginLeft={theme.spacing(2)}>
        <TooltipText text={t('serviceArea.newImportArea')}>
          <Icon component={IconAdd} />
        </TooltipText>
      </MapBtn>
      <MapBtn
        aria-label={t('serviceArea.newCoordinates')}
        onClick={handleOpenVectorModal}
        marginLeft={theme.spacing(1)}>
        <TooltipText text={t('serviceArea.newCoordinates')}>
          <Icon
            component={IconImport}
            sx={{
              fill: theme.palette.error.main,
              '&:hover': { fill: theme.palette.error.main },
            }}
          />
        </TooltipText>
      </MapBtn>
    </MapBtnWrapper>
  )
}
